import { ActionType } from 'typesafe-actions';
import * as actions from './../actions/album.action';
import { combineReducers } from 'redux';

import { FullAlbum } from '../../models/Album';
import {
  ALBUM_FETCH_SUCCESS,
  ALBUM_FETCH_REQUEST,
  ALBUM_FETCH_ERROR,
} from '../constants/general.constants';
import { HubError } from '../../models/HubError';
import { LoadingState } from '../../models/LoadingState';

export type AlbumState = {
  albumById: { [albumId: string]: FullAlbum };
  loadingStateById: { [albumId: string]: LoadingState };
  errorsById: { [albumId: string]: HubError | null };
};

export type AlbumAction = ActionType<typeof actions>;

export const album = combineReducers<AlbumState, AlbumAction>({
  albumById: (state = {}, action) => {
    switch (action.type) {
      case ALBUM_FETCH_SUCCESS: {
        const newState = Object.assign({}, state);
        newState[action.payload.id] = action.payload;
        return newState;
      }
      default:
        return state;
    }
  },
  loadingStateById: (state = {}, action) => {
    switch (action.type) {
      case ALBUM_FETCH_REQUEST: {
        const newState = Object.assign({}, state);
        newState[action.payload] = LoadingState.LOADING;
        return newState;
      }
      case ALBUM_FETCH_SUCCESS: {
        const newState = Object.assign({}, state);
        newState[action.payload.id] = LoadingState.SUCCESS;
        return newState;
      }
      case ALBUM_FETCH_ERROR: {
        const newState = Object.assign({}, state);
        newState[action.payload.id] = LoadingState.ERROR;
        return newState;
      }
      default: {
        return state;
      }
    }
  },
  errorsById: (state = {}, action) => {
    switch (action.type) {
      case ALBUM_FETCH_REQUEST: {
        const newState = Object.assign({}, state);
        newState[action.payload] = null;
        return newState;
      }
      case ALBUM_FETCH_ERROR: {
        const newState = Object.assign({}, state);
        newState[action.payload.id] = action.payload.err;
        return newState;
      }
      default: {
        return state;
      }
    }
  },
});
